module.exports = __webpack_public_path__ + "img/camera-switch.e3f781fc.png";